import AllTxnTable from './AllTxnTable';
import CoinToCoinAccountTitle from '../CoinToCoinAccountTitle';
import { accountManagementApi } from '@/api/user/accountManagementApi';
import { getterTypes } from '@/store/getter-types';
import { mapGetters } from 'vuex';
import { assetsApi } from '@/api/assetsApi';
import GForm from '../GForm';
import tool from '@/common/js/tool';
import moment from 'moment';

export default {
  name: 'Transaction',
  data() {
    return {
      transactions: {
        data: {},
        loading: false,
        query: {
          current: 1,
          size: 10
        }
      },
      formConfig: [
        { key: 'from', label: this.$t('labels.transaction.from'), compType: 'datetime', dateColumn: true },
        { key: 'to', label: this.$t('labels.transaction.to'), compType: 'datetime', dateColumn: true }
      ],
      form: {
        from: '',
        to: ''
      },
      // 控制批量撤销modal显示与隐藏
      cancelAllModalShow: false,
      cancelAllCommitting: false,
      // 控制撤销单个订单提示modal显示与隐藏
      cancelOrderModalShow: false,
      cancelOrderCommitting: false,
      cancelOrderId: '',
      cancelOrderPair: '',
      filterData: {
        size: 1,
        current: 1
      },
      businessType_tableFilter: {},
      businessSubType_tableFilter: {},
      coinId: 1001
    };
  },
  methods: {
    // async getList(pagination) {
    //   if (pagination.page) {
    //     if (typeof pagination.page === 'number') {
    //       this.transactions.query.current = pagination.page;
    //     } else {
    //       this.transactions.query.current = 1;
    //     }
    //   } else {
    //     this.transactions.query.current = 1;
    //   }

    //   if (pagination.rowsPerPage) {
    //     if (typeof pagination.rowsPerPage === 'number') {
    //       this.transactions.query.size = pagination.rowsPerPage;
    //     } else {
    //       this.transactions.query.size = 10;
    //     }
    //   } else {
    //     this.transactions.query.size = 10;
    //   }

    //   await this.search();
    // },
    search() {
      if (!this.form.from) {
        this.form.from = moment().format('YYYY-MM-DD');
      }

      if (!this.form.to) {
        this.form.to = moment().format('YYYY-MM-DD');
      }

      let from = new Date(this.form.from).getTime();
      let to = new Date(this.form.to).getTime();

      if (from > to) {
        let tmpFrom = this.form.from;
        let tmpTo = this.form.to;
        this.form.from = tmpTo;
        this.form.to = tmpFrom;
      }

      this.getAllTransaction(
        this.transactions.query.current,
        this.transactions.query.size,
        this.form.from,
        this.form.to,
        this.coinId
      );
    },
    getAllTransaction(current, size, start, end, coinId) {
      if (this.Getter_Token) {
        this.transactions.loading = true;
        accountManagementApi
          .getAllTransactions(current, size, start, end, coinId)
          .then(res => {
            let data = res.data;
            this.transactions.loading = false;
            this.transactions.data = data;
          })
          .catch(() => {
            this.transactions.loading = false;
          });
      } else {
        console.error('Invalid token');
      }
    },
    getBusinessType() {
      assetsApi.enumOptions_api.getBusinessType().then(res => {
        let newData = tool.convertArrToOptions(res.data, 'display', 'value', true);
        newData.forEach(item => {
          this.businessType_tableFilter[item.value] = item.label;
        });
        this.businessTypeOptions = newData;
      });
    },
    getBusinessSubType() {
      assetsApi.enumOptions_api.getBusinessSubType().then(res => {
        let newData = tool.convertArrToOptions(res.data, 'display', 'value', true);
        newData.forEach(item => {
          this.businessSubType_tableFilter[item.value] = item.label;
        });
        // this.businessTypeOptions = newData;
      });
    }
  },
  computed: {
    ...mapGetters([getterTypes.Getter_Token, getterTypes.Getter_Assets_List])
  },
  watch: {
    coinId() {
      // Reset current page to 1 when coin changes
      this.transactions.query.current = 1;
      this.getAllTransaction(
        this.transactions.query.current,
        this.transactions.query.size,
        this.form.from,
        this.form.to,
        this.coinId
      );
    },
    'transactions.query'() {
      this.getAllTransaction(
        this.transactions.query.current,
        this.transactions.query.size,
        this.form.from,
        this.form.to,
        this.coinId
      );
    }
  },
  created() {
    this.coinId = this.Getter_Assets_List[0].value;
  },
  mounted() {
    this.search();
    this.getBusinessType();
    this.getBusinessSubType();
  },
  components: { AllTxnTable, CoinToCoinAccountTitle, GForm }
};
